import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useOwnerAuth } from "@/lib/owner-auth-context";

export default function OwnerLogin() {
  const { login } = useOwnerAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome, Super Owner");
      navigate("/owner");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle, #10b981 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
      <div className="relative w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-xs text-gray-400 hover:text-white mb-6" data-testid="back-to-app">
          ← Kembali ke Custora
        </Link>
        <div className="bg-gray-900 border border-gray-800 rounded-xl p-8">
          <div className="flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-emerald-400">
            <ShieldCheck size={14} /> Super Owner
          </div>
          <h1 className="mt-3 font-heading text-3xl font-bold">Platform Admin Console</h1>
          <p className="mt-2 text-gray-400 text-sm">Login khusus untuk pemilik platform Custora.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-gray-300">Email</Label>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
                placeholder="owner@custora.id"
                className="mt-1.5 bg-gray-800 border-gray-700 text-white h-11"
                data-testid="owner-email-input" />
            </div>
            <div>
              <Label className="text-gray-300">Password</Label>
              <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
                className="mt-1.5 bg-gray-800 border-gray-700 text-white h-11"
                data-testid="owner-password-input" />
            </div>
            <Button type="submit" disabled={loading}
              className="w-full h-11 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold"
              data-testid="owner-login-btn">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Masuk ke Console
            </Button>
          </form>

          <div className="mt-6 text-[11px] text-gray-500 border-t border-gray-800 pt-4">
            Akses ini terbatas untuk Super Owner platform. Semua aktivitas dicatat di audit log.
          </div>
        </div>
      </div>
    </div>
  );
}
